import React from "react"
import { t } from "i18next"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { setSearchBikeFleet } from "../../slice/bikeFleetSlice"
import { useCurrentSearchParams } from "hooks/useCurrentSearchParams"
import { hasBikeIntoBikeFleetSelector } from "features/bikeFleet/slice/bikeFleetSelector"
import {} from "utils"

type SearchBikeFleetProps = {
	onResetPage: () => void
}

export const SearchBikeFleet: React.FC<SearchBikeFleetProps> = ({ onResetPage }) => {
	const dispatch = useAppDispatch()
	const search = useAppSelector((state) => state.bikeFleet.searchBikeFLeet)
	const hasBikeIntoBikeFleet = useAppSelector(hasBikeIntoBikeFleetSelector)
	const [{ status }] = useCurrentSearchParams({ status: 1 })

	const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value
		dispatch(setSearchBikeFleet({ search: value, status }))
		onResetPage()
	}
	return (
		<div className="flex-1">
			<div className={"c-form-group c-form-group--picto mb-7 md:mb-0"}>
				<label htmlFor="tableglobalFilter" className="c-label mb-1">
					{t("table.search", { ns: "team" })}
				</label>
				<svg
					className="c-input-picto"
					xmlns="http://www.w3.org/2000/svg"
					height="20"
					width="20"
					viewBox="0 0 512 512"
				>
					<path d="M505.749 475.587l-145.6-145.6c28.203-34.837 45.184-79.104 45.184-127.317C405.333 90.926 314.41.003 202.666.003S0 90.925 0 202.669s90.923 202.667 202.667 202.667c48.213 0 92.48-16.981 127.317-45.184l145.6 145.6c4.16 4.16 9.621 6.251 15.083 6.251s10.923-2.091 15.083-6.251c8.341-8.341 8.341-21.824-.001-30.165zM202.667 362.669c-88.235 0-160-71.765-160-160s71.765-160 160-160 160 71.765 160 160-71.766 160-160 160z" />
				</svg>
				<input
					disabled={!hasBikeIntoBikeFleet}
					className={"c-input pl-12"}
					id={"tableglobalFilter"}
					name={"tableglobalFilter"}
					type={"text"}
					placeholder={`${t("bikeFleet.search", { ns: "bike" })}`}
					value={search}
					style={{ maxWidth: "400px" }}
					onChange={onSearch}
				/>
			</div>
		</div>
	)
}
